var rich_content_viewer_default = {
  "fontElementMap": "HWXM9",
  "wrapper": "hJSlc",
  "pluginContainerMobile": "NyYwr",
  "viewer": "wBmYp",
  "android": "SfLIY",
  "rootedTraversedContent": "_5DQNQ",
  "atomic": "bDTIa",
  "toolbar": "e-vq-",
  "block": "qVEhl"
};
export {
  rich_content_viewer_default as default
};
//# sourceMappingURL=rich-content-viewer-scss.js.map
